import axios from "axios";
import http from "@/api/http/http";

export default {
  list (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.get(`${process.env.VUE_APP_API}/admin/request-consulting/list`, {
      ...header,
      params: params
    })
      .then(cb)
      .catch(errCb)
  },
  getCount (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.get(`${process.env.VUE_APP_API}/admin/request-consulting/statics`, header)
      .then(cb)
      .catch(errCb)
  },
  setComplete (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.patch(`${process.env.VUE_APP_API}/admin/request-consulting/${params.id}`,null, header)
      .then(cb)
      .catch(errCb)
  },
  setConfirmed (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.patch(`${process.env.VUE_APP_API}/admin/request-consulting/${params.id}/confirmed`, {
      kakaoName: params.kakaoName,
    }, header)
      .then(cb)
      .catch(errCb)
  },
  setDelete (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.delete(`${process.env.VUE_APP_API}/admin/request-consulting/${params.id}`, header)
      .then(cb)
      .catch(errCb)
  },
  hideFromKakaoManagement (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.delete(`${process.env.VUE_APP_API}/admin/request-consulting/${params.id}/kakao-management`, header)
      .then(cb)
      .catch(errCb)
  },
  sendMessage (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.patch(`${process.env.VUE_APP_API}/admin/request-consulting/${params.id}/message`,{}, header)
      .then(cb)
      .catch(errCb)
  },
  deleteAll (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.delete(`${process.env.VUE_APP_API}/admin/request-consulting/all`, header)
      .then(cb)
      .catch(errCb)
  },
  downloadExcel (params: any, cb: (response) => void, errCb: (response) => void) {
    const accessToken = localStorage.ACCESS_TOKEN
    axios({
      method: 'get',
      url: `${process.env.VUE_APP_API}/admin/request-consulting/excel`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params
    }).then(cb)
      .catch(errCb)
  },
  downloadStaticsExcel ( cb: (response) => void, errCb: (response) => void) {
    const accessToken = localStorage.ACCESS_TOKEN
    axios({
      method: 'get',
      url: `${process.env.VUE_APP_API}/admin/request-consulting/excel/page-statics`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then(cb)
      .catch(errCb)
  },
  searchStudentCodes (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.get(`${process.env.VUE_APP_API}/admin/request-consulting/student-codes`, {
      ...header,
      params: params
    })
      .then(cb)
      .catch(errCb)
  },
  downloadStudentCodesExcel (params: any, cb: (response) => void, errCb: (response) => void) {
    const accessToken = localStorage.ACCESS_TOKEN
    axios({
      method: 'get',
      url: `${process.env.VUE_APP_API}/admin/request-consulting/student-codes/excel`,
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params
    }).then(cb)
      .catch(errCb)
  },
  createRequestConsultingByExcel( params: any, cb: (response) => void, errCb: (response) => void) {
    const formData = new FormData()
    formData.append('file', params.file)
    const header = http.setHeaders()
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_API}/admin/request-consulting/upload-excel`,
      responseType: 'blob',
      data: formData,
      ...header
    })
      .then(cb)
      .catch((error) => {
        console.log('error', error)
        if (error.response && error.response.data && error.response.data.message) {
          errCb(error.response.data);
        } else {
          errCb({ message: "An unknown error occurred" });
        }
      })
  },
}
